import React, { useEffect, useState } from 'react'
import WarehouseRetur from '../WarehouseRetur'
import { useDispatch } from 'react-redux'
import { getReturPembelian } from '../../../../models/penerimaan/report_penerimaan_m'

import Paginate from '../../../pagination/Paginate'
import Moment from 'react-moment'

import { NumericFormat } from 'react-number-format';
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const WarehouseReturValidation = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [retur, setRetur] = useState([]);
    const [pagination, setPagination] = useState([]);

    const getData = async(page) => {
        try {
            const response = await dispatch(getReturPembelian(page)).unwrap().catch((err) => {});
            setRetur(response.data);
            setPagination(response.pagination);
        } catch (error) {
            
        }
    }

    useEffect(() => {
        getData(1);
    }, []);

    const handlePagination = (_, page) => {
        return getData(page)
    }

    const onDetail = (code) => {
        return navigate(`${code}`)
    }

    return (
        <WarehouseRetur>
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <div style={{lineHeight: '60%'}}>
                                <h3>VALIDASI RETUR PEMBELIAN</h3>
                                <span>List Data Retur Pembelian</span>
                            </div>
                        </div>

                        <div className="table-responsive mt-3">
                            <table className="table align-middle">
                                <thead>
                                    <tr>
                                        <th className="table-border-start text-center" style={{width: '5%'}}>
                                            <span className="form-control">No</span>
                                        </th>
                                        <th>
                                            <span className="form-control">Kode Pembelian</span>
                                        </th>
                                        <th>
                                            <span className="form-control">Tanggal Penerimaan</span>
                                        </th>
                                        <th>
                                            <span className="form-control">Supplier</span>
                                        </th>
                                        <th>
                                            <span className="form-control">Total Pembelian</span>
                                        </th>
                                        <th className="text-center">
                                            <span className="form-control">Status</span>
                                        </th>
                                        <th className="table-border-end text-center" style={{width: '10%'}}>
                                            <span className="form-control">Action</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        retur.map((data) => (
                                            <tr key={data.no}>
                                                <td className="text-center">{data.no}</td>
                                                <td>{data.code_purchase_total}</td>
                                                <td>
                                                    <Moment format="dddd, DD MMMM YYYY">{ data.tgl_penerimaan }</Moment>
                                                </td>
                                                <td>{data.supplier}</td>
                                                <td>
                                                    <NumericFormat 
                                                        value={ data.total_pembayaran } 
                                                        allowLeadingZeros 
                                                        thousandSeparator="," 
                                                        valueIsNumericString
                                                        prefix="Rp. "
                                                        displayType="text"
                                                        renderText={(value) => <span>{value}</span>}
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    <span className="badge bg-orange">Belum Divalidasi</span>
                                                </td>
                                                <td className="text-center">
                                                    <Button onClick={() => onDetail(data.code_purchase_total)} size="small" variant="contained" color="primary">
                                                        Validasi
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </WarehouseRetur>
    )
}

export default WarehouseReturValidation
